import { post } from '../../utils/http';
// 任务查询
export const pageTaskRecord = (params) => post('/wapc/taskCenter/pageTaskRecord', params);
